export default __webpack_public_path__ + "static/media/06_09.66e92ef7.jpg";